import { useEffect, type FC } from 'react'
import { Button } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { useRouter } from '@egw/router'
import { sendEvent } from '@egw/events'
import { riskService } from '@egw/risk-service'
import { Layout, PageHeader } from '../../../components'
import { setRecoveryFlowData } from '../../../services'
import { ChannelType } from '../../../models'

export const RecoveryMethodPage: FC = () => {
  const { t } = useTranslation('features-auth')
  const { navigate } = useRouter()

  const setChannel = (channelType: ChannelType): void => {
    // Set the new recovery flow data, it will overwrite the existing data to start a new flow
    setRecoveryFlowData({ channel: channelType, isPhoneVerified: false, isEmailVerified: false })
  }

  useEffect(() => {
    void riskService.resetSession()
  }, [])

  return (
    <Layout>
      <PageHeader title={t('recovery.title')} backLinkUrl={WEALTH_ROUTES.RECOVERY_METHOD.backPath} />
      <p className="mb-sm">{t('recovery.method_message')}</p>
      <div className="flex-1 md:hidden" />
      <div className="flex flex-col md:flex-row gap-2xs">
        <Button
          variant="secondary"
          testId="sendTextOtp_secondary_btn"
          onClick={() => {
            sendEvent('user_verificationMethod_click', {
              eventSource: 'egWealth',
              category: 'passkey-recovery',
              subCategory: 'verification',
              verificationType: 'phone',
            })
            setChannel(ChannelType.PHONE)
            navigate(WEALTH_ROUTES.RECOVERY_SEND_PHONE.path)
          }}
        >
          {t('recovery.method_sms')}
        </Button>

        <Button
          variant="secondary"
          testId="sendTextOtp_secondary_btn"
          onClick={() => {
            sendEvent('user_verificationMethod_click', {
              eventSource: 'egWealth',
              category: 'passkey-recovery',
              subCategory: 'verification',
              verificationType: 'email',
            })
            setChannel(ChannelType.EMAIL)
            navigate(WEALTH_ROUTES.RECOVERY_SEND_EMAIL.path)
          }}
        >
          {t('recovery.method_email')}
        </Button>
      </div>
    </Layout>
  )
}
